const SampleData = [
  {
    mapperProfileName: "Profile A",
    description: "This is a description about profile A",
    sourceType: "File",
    targetType: "Json",
    category: "Payroll",
    level: "Global",
    associatedPlans: "Plan A",
    isActive: true,
    profileType: "Input Profile",
    filter_type: "Plan Specific",
  },

  {
    mapperProfileName: "Profile B",
    description: "This is a description about profile B",
    sourceType: "Json",
    targetType: "CORE",
    category: "Payroll",
    level: "Global",
    // associatedPlans:"Plan B",
    isActive: true,
    profileType: "Output Profile",
    filter_type: "Generic",
  },

  {
    mapperProfileName: "Profile C",
    description: "This is a description about profile C",
    sourceType: "File",
    targetType: "File",
    category: "Payroll",
    level: "Global",
    associatedPlans: "Plan C",
    isActive: true,
    profileType: "Pass Through",
    filter_type: "Plan Specific",
  },
  {
    mapperProfileName: "Profile A",
    description: "This is a description profile A",
    sourceType: "File",
    targetType: "Json",
    category: "Payroll",
    level: "Global",
    associatedPlans: "Plan A",
    isActive: true,
    profileType: "Input Profile",
    filter_type: "Plan Specific",
  },

  {
    mapperProfileName: "Profile B",
    description: "This is a description profile B",
    sourceType: "Json",
    targetType: "CORE",
    category: "Payroll",
    level: "Global",
    // associatedPlans:"Plan B",
    isActive: true,
    profileType: "Input Profile",
    filter_type: "Generic",
  },

  {
    mapperProfileName: "Profile C",
    description: "This is a description about profile C",
    sourceType: "File",
    targetType: "Json",
    category: "Payroll",
    level: "Global",
    associatedPlans: "Plan C",
    isActive: true,
    profileType: "Input Profile",
    filter_type: "Generic",
  },
];
export default SampleData;
